import { firebaseAppProvider } from "../FirebaseAppProvider";
import { getAnalytics } from "firebase/analytics";

class AnalyticsReporter {
    initialize() {
        this._analytics = getAnalytics(firebaseAppProvider.provide());
    }
}

export const analyticsReporter = new AnalyticsReporter();